import {graphql} from 'react-relay'

import {deployLocator} from './Deployments.rest'

export const deploymentsQuery = graphql`
  query DeploymentsQuery(
    $possibleSnapshotDeploymentsLocator: String!
    $possibleArtifactDeploymentsLocator: String!
  ) {
    possibleSnapshotDeployments: buildTypes(locator: $possibleSnapshotDeploymentsLocator) {
      count
      ...DeploymentsFragment
    }
    possibleArtifactDeployments: buildTypes(locator: $possibleArtifactDeploymentsLocator) {
      count
      ...DeploymentsFragment
    }
  }
`

export const getDeploymentsQueryVariables = (buildTypeId: string) => ({
  possibleSnapshotDeploymentsLocator: `${deployLocator},snapshotDependency(from:(id:${buildTypeId}))`,
  possibleArtifactDeploymentsLocator: `${deployLocator},artifactDependency(from:(id:${buildTypeId}),recursive:false)`,
})
